"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const react_1 = __importStar(require("react"));
const hooks_1 = require("../../../hooks");
const getterUtils_1 = require("./getterUtils");
const common_1 = require("../../../utils/common");
const TGOptionLazyModalWeb_1 = __importDefault(require("./TGOptionLazyModal/TGOptionLazyModalWeb"));
/**
 * Modal dialog option selector where options are a static array of values
 * @param props
 */
const TGOptionSelectorModalWeb = props => {
    const { options, value, onDone, pathToValue, fetchMoreData, clearPageInfo, searchText, handleSearchText, translateFunction = text => text } = props, modalProps = __rest(props, ["options", "value", "onDone", "pathToValue", "fetchMoreData", "clearPageInfo", "searchText", "handleSearchText", "translateFunction"]);
    const arrayValue = (0, react_1.useMemo)(() => {
        const arrayValues = (() => {
            if (value === undefined) {
                return [];
            }
            if (Array.isArray(value)) {
                return value;
            }
            return [value];
        })();
        return arrayValues.map(x => options.find(y => x === (0, getterUtils_1.getValue)(y, pathToValue))).filter(common_1.isNotUndefined);
    }, [value, pathToValue, options]);
    const { fetchMoreData: fetchLazyData, fetchAllData, fetchedLength, currentData, } = (0, hooks_1.useLazyArrayDataProvider)({
        data: options,
        recordsPerPage: 50,
    });
    const handleDone = (0, react_1.useCallback)((value) => {
        if (props.multiSelect) {
            onDone(value.map(val => (0, getterUtils_1.getValue)(val, pathToValue)));
        }
        else {
            onDone(value.length > 0 ? (0, getterUtils_1.getValue)(value[0], pathToValue) : undefined);
        }
    }, [props.multiSelect, onDone, pathToValue]);
    return (react_1.default.createElement(TGOptionLazyModalWeb_1.default, Object.assign({}, modalProps, { onDone: handleDone, value: arrayValue, data: options, fetchMoreData: () => (fetchMoreData ? fetchMoreData() : fetchLazyData()), refetch: (_, onUpdate) => {
            fetchAllData();
            onUpdate && onUpdate(currentData);
        }, searchText: searchText, handleSearchText: handleSearchText, isAllLoaded: currentData.length <= fetchedLength, totalCount: currentData.length, pathToValue: pathToValue, translateFunction: translateFunction })));
};
exports.default = TGOptionSelectorModalWeb;
//# sourceMappingURL=TGOptionSelectorModalWeb.js.map